namespace Portico.Models.Enterprise {

	export interface IAccountAddress {
		id: number;
		type: string;
		receiverFirstName: string;
		receiverLastName: string;
		address1: string;
		address2: string;
		city: string;
		state: string;
		zip: string;
		country: string;
    }

	export class AccountAddress implements IAccountAddress {
		id: number;
		type: string;
		receiverFirstName: string;
		receiverLastName: string;
		address1: string;
		address2: string;
		city: string;
		state: string;
		zip: string;
		country: string;

		constructor(obj?: IAccountAddress) {
			this.id = null;
			this.type = null;
			this.receiverFirstName = '';
			this.receiverLastName = '';
			this.address1 = '';
			this.address2 = '';
			this.city = '';
			this.state = '';
			this.zip = '';
			this.country = 'US';

			if (obj) {
				this.id = obj.id || null;
				this.type = obj.type || null;
				this.receiverFirstName = obj.receiverFirstName || '';
				this.receiverLastName = obj.receiverLastName || '';
				this.address1 = obj.address1 || '';
				this.address2 = obj.address2 || '';
				this.city = obj.city || '';
				this.state = obj.state || '';
				this.zip = obj.zip || '';
				this.country = obj.country || 'US';
			}
        }
    }
}
